<template>
  <div class="d-flex flex-wrap">
    <div
      v-for="({ icon, label, color, visible }, index) in tags"
      v-show="visible"
      :key="`tag-item-${index}`"
      class="mx-1 my-1"
    >
      <span
        class="badge badge-pill badge-primary bg-secondary-34 p-2 px-2"
        :class="`border-color--${color}`"
      >
        <em :class="`${icon} color-${color}`" />
        <span class="font-weight-bold ml-1" :class="`color-${color}`">
          {{ label }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import serviceType from '@/views/scholarship/attendance/utils/serviceTypeEnum.js';
import payrollReceiveType from '@/utils/constants/payrollReceiveTypes.js';

export default {
  name: 'PaymentTags',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    tags() {
      return [
        {
          icon: 'fas fa-user-check',
          label: 'Analizado',
          color: 'gray-7',
          visible: this.value.analyzedById,
        },
        {
          icon: 'fas fa-envelope',
          label: 'Email',
          color: 'green',
          visible:
            [
              serviceType.educativo,
              serviceType.terapiaDeHabla,
              serviceType.terapiaOcupacional,
              serviceType.terapidaPsicologica,
              serviceType.terapiaFisica,
              serviceType.terapiaOromotora,
              serviceType.otros,
            ].includes(this.value.peiAnalysisServiceId) &&
            this.value.payrollDate &&
            this.value.isManualAssistanceFlag === true &&
            this.value.payrollReceiveTypeId === payrollReceiveType.Email,
        },
        {
          icon: 'fas fa-envelope',
          label: 'Correo Interno',
          color: 'green',
          visible:
            [
              serviceType.educativo,
              serviceType.terapiaDeHabla,
              serviceType.terapiaOcupacional,
              serviceType.terapidaPsicologica,
              serviceType.terapiaFisica,
              serviceType.terapiaOromotora,
              serviceType.otros,
            ].includes(this.value.peiAnalysisServiceId) &&
            this.value.payrollDate &&
            this.value.isManualAssistanceFlag === true &&
            this.value.payrollReceiveTypeId ===
              payrollReceiveType.CorreoInterno,
        },
        {
          icon: 'fas fa-usd-circle',
          label: 'Ajuste Automático',
          color: 'secondary-37',
          visible:
            this.value.peiAnalysisServiceId == serviceType.educativo &&
            this.value.automaticAdjustmenAmt != null,
        },
        {
          icon: 'fas fa-usd-circle',
          label: 'Ajuste Manual',
          color: 'secondary-37',
          visible: this.value.manualAdjustmentReasonCd != null,
        },
        {
          icon: 'fas fa-plus-circle',
          label: 'Pago Adicional',
          color: 'secondary-20',
          visible: this.value.hasAdditionalPayments,
        },
        {
          icon: 'fas fa-people-arrows',
          label: 'Relación de Pago - Principal',
          color: 'red',
          visible:
            this.value.summaryParentId != null &&
            this.value.summaryParentId == this.value.assistanceSummaryId,
        },
        {
          icon: 'fas fa-people-arrows',
          label: 'Relación de Pago - Relacionado',
          color: 'red',
          visible:
            this.value.summaryParentId != null &&
            this.value.summaryParentId != this.value.assistanceSummaryId,
        },
        {
          icon: 'fas fa-tasks-alt',
          label: 'Informe de Progreso',
          color: 'yellow-star',
          visible: this.value.hasCompliance,
        },
        {
          icon: 'fas fa-file-invoice-dollar',
          label: 'Facturación en Línea SAEE',
          color: 'green',
          visible:
            this.value.payrollReceiveTypeId ===
            payrollReceiveType.FacturacionEnLineaSAEE,
        },
        {
          icon: 'fas fa-file-invoice-dollar',
          label: 'Facturación en Línea RP',
          color: 'green',
          visible:
            this.value.payrollReceiveTypeId ===
            payrollReceiveType.FacturacionEnLineaRP,
        },
        {
          icon: 'fas fa-comment',
          label: 'Comentario',
          color: 'green',
          visible: this.value.hasComments,
        },
      ];
    },
  },
};
</script>

<style scoped></style>
